import React, { useEffect } from "react";
import { Button, FieldGroup, FieldRow, FieldSet } from "react-corner-ds";
import { useTranslation } from "react-i18next";
import style from "./CtWidgetContactB2BSuccess.module.css";

interface ICtWidgetContactB2BSuccess {
  selectedLang: string;
  hideTitle: boolean;
}

const CtWidgetContactB2BSuccess: React.FC<ICtWidgetContactB2BSuccess> = ({
  selectedLang,
  hideTitle,
}) => {
  const { t } = useTranslation();

  const scrollDataWidget = document.querySelector(
    '[data-widget="ct-widget-contactB2B"]'
  )?.scrollTop;

  window.scrollTo({ top: scrollDataWidget, behavior: "smooth" });

  useEffect(() => {
    window.buildSuccessFormPageName("contactb2b");
  }, []);

  return (
    <div className={style.action}>
      <div className={style.contactB2BSuccess}>
        {!hideTitle ? (
          <>
            <h1
              className={style.contactB2BTitle}
            >{t`screens.contactB2B.formTitle`}</h1>
            <h2
              className={style.contactB2BSubTitle}
            >{t`screens.contactB2B.formSubTitle`}</h2>
          </>
        ) : (
          <></>
        )}

        <div className={style.contactB2BSuccess}>
          <FieldSet>
            <FieldRow>
              <FieldGroup customCssClass={style.contactB2BSuccessTitle}>
                <h3>
                  <i className="cticonapp-ok-2"></i>
                  <span>{t`success.contactB2B.pageTitle`}</span>
                </h3>
              </FieldGroup>
            </FieldRow>
            <FieldRow>
              <FieldGroup customCssClass={style.contactB2BSuccessSubTitle}>
                <span>{t`success.contactB2B.pageSubtitle`}</span>
              </FieldGroup>
            </FieldRow>
            <FieldRow>
              <FieldGroup customCssClass={style.contactB2BSuccessButton}>
                <Button
                  text={t`success.contactB2B.checkPlatform`}
                  onClick={() => {
                    window.location.replace(
                      window.location.origin +
                        `/${selectedLang}/${t`success.contactB2B.platforms`}`
                    );
                  }}
                />
              </FieldGroup>
            </FieldRow>
          </FieldSet>
        </div>
      </div>
    </div>
  );
};

export default CtWidgetContactB2BSuccess;
